import React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import ComingSoon from "./ComingSoon"
import Home from "./Home"
import Redirect from "./Redirect"
import Terms from "./Terms"

const App: React.FC = () => {
  return (
    <div>
      <Router>
        <Switch>
          <Route path="/discord">
            <Redirect redirectUrl="https://discord.gg/bNcZjFe" />
          </Route>

          <Route path="/project/picasso">
            <Redirect redirectUrl="https://github.com/Beatso/Picasso#readme" />
          </Route>
          <Route path="/project/schubert">
            <Redirect redirectUrl="https://github.com/Beatso/Schubert#readme" />
          </Route>
          <Route path="/project/pinn">
            <Redirect redirectUrl="https://github.com/Beatso/Pinn#readme" />
          </Route>
          <Route path="/project/redditspyglass">
            <Redirect redirectUrl="https://beatso.github.io/reddit-spyglass/" />
          </Route>

          <Route path="/coming-soon">
            <ComingSoon />
          </Route>

          <Route path="/terms">
            <Terms />
          </Route>

          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  )
}

export default App
